export default [
  { to: 'akut', title: 'AKUT' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'lakemedel', title: 'Läkemedel' },
  { to: 'instruktioner', title: 'Instruktioner' },
  { to: 'info', title: 'Information' },
  { to: 'calculator', title: 'Dosberäknare' },
];
